import { ReactElement } from 'react';
import { Autocomplete } from '@weareopenr/component-library';
import { IRange } from 'src/api/getRanges';
import styles from './RangesField.module.scss';

interface RangesFieldProps {
  ranges: IRange[];
  isLoading: boolean;
  value: string[];
  onChange: (rangeIds: string[]) => void;
  error?: string;
}

export const RangesField = ({ ranges, isLoading, value, onChange, error }: RangesFieldProps): ReactElement => (
  <div className={styles['autocomplete']}>
    <Autocomplete
      multiple
      name="ranges"
      label="Ranges"
      loading={isLoading}
      options={ranges.map((range) => ({ value: range.range_id, label: range.name }))}
      value={value}
      onChange={onChange}
      limitChips={4}
      error={error}
    />
  </div>
);

export default RangesField;
